import { useRef } from "react";

export default function useHelpModalController() {
  const draggableRef = useRef(null);
  return { draggableRef };
}
